import { LoadableAfterPaint } from '@confluence/loadable';

export const CopyWithRovoLoadable = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-CopyWithRovo" */ '../src/CopyWithRovo.tsx'))
			.CopyWithRovo,
	loading: () => null,
});
